import { render, staticRenderFns } from "./SOW.vue?vue&type=template&id=ed752250&"
import script from "./SOW.vue?vue&type=script&lang=js&"
export * from "./SOW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports